// eslint-disable-next-line import/prefer-default-export
export const DURATION_MODIFIER = 3
